import { __decorate } from "tslib";
import { Mixins, Component } from 'vue-property-decorator';
import FormHeader from '@/components/v2/FormHeader.vue';
import ActionButton from '@/components/action_button/Index.vue';
let SalesPartnerWelcomeDialog = class SalesPartnerWelcomeDialog extends Mixins() {
    constructor() {
        super(...arguments);
        this.toggle = true;
    }
    get welcomeImagePath() {
        return require('@/assets/images/welcome_sales_partner.png');
    }
    onSubmit() {
        this.toggle = !this.toggle;
    }
};
SalesPartnerWelcomeDialog = __decorate([
    Component({
        components: {
            FormHeader,
            ActionButton,
        },
    })
], SalesPartnerWelcomeDialog);
export default SalesPartnerWelcomeDialog;
